'use client';

import React from 'react';
import { Box, Text, VStack } from '@skin-seoul/design-system';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import { useParams } from 'next/navigation';
const ProductDescription = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      product
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  return <Box width="100%" data-sentry-element="Box" data-sentry-component="ProductDescription" data-sentry-source-file="ProductDescription.tsx">
      <VStack gap={3} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="ProductDescription.tsx">
        <Text textStyle={{
        base: 'paragraph.small',
        tablet: 'paragraph.medium'
      }} color="neutral.400" width="100%" fontWeight="regular" whiteSpace="pre-line" data-sentry-element="Text" data-sentry-source-file="ProductDescription.tsx">
          {product?.description?.replace(/<br\s*\/?>/gi, '\n')}
        </Text>
      </VStack>
    </Box>;
};
export default ProductDescription;